import { theme } from './global.js';

// "Deliver to" emirate: remembered in the browser, saved on the cart (attribute "Emirate"), and used to pre-fill
// the checkout address (United Arab Emirates + the chosen emirate).
const KEY = 'energy:emirate';
const FALLBACK = 'Dubai';

export function getEmirate() {
  try {
    return localStorage.getItem(KEY) || FALLBACK;
  } catch (error) {
    return FALLBACK;
  }
}

function checkoutUrl() {
  const emirate = getEmirate();
  const params = new URLSearchParams({
    'checkout[shipping_address][country]': 'United Arab Emirates',
    'checkout[shipping_address][province]': emirate,
    'checkout[shipping_address][city]': emirate.replace('al-', 'Al '),
  });
  return `/checkout?${params.toString()}`;
}

async function saveToCart(emirate) {
  try {
    await fetch(`${theme.routes.cartUpdate || '/cart/update.js'}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Emirate: emirate.replace('al-', 'Al ') } }),
    });
  } catch (error) {
    /* the checkout still gets the emirate from the URL */
  }
}

class EmiratePicker extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-emirate-toggle]');
    this.panel = this.querySelector('[data-emirate-panel]');
    this.label = this.querySelector('[data-emirate-label]');
    this.options = Array.from(this.querySelectorAll('[data-emirate-option]'));
    this.button.addEventListener('click', () => this.toggle());
    this.options.forEach((option) => option.addEventListener('click', () => this.select(option.dataset.emirateOption)));
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
    this.render(getEmirate());
  }

  render(emirate) {
    this.label.textContent = emirate.replace('al-', 'Al ');
    this.options.forEach((option) => option.setAttribute('aria-selected', option.dataset.emirateOption === emirate));
  }

  select(emirate) {
    try {
      localStorage.setItem(KEY, emirate);
    } catch (error) {
      /* storage unavailable: the picker still works for this page view */
    }
    this.render(emirate);
    this.close();
    saveToCart(emirate);
    document.dispatchEvent(new CustomEvent('emirate:change', { detail: { emirate } }));
  }

  toggle() {
    if (this.panel.hidden) this.open(); else this.close();
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('emirate-picker')) customElements.define('emirate-picker', EmiratePicker);

// Every route to checkout (drawer link, cart page button) goes via the pre-filled URL.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
  const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
  if (!link && !button) return;
  event.preventDefault();
  saveToCart(getEmirate()).finally(() => { window.location.href = checkoutUrl(); });
}, true);
